import { SvgConsentOne, SvgConsentThreeATwoEnd, SvgConsentThreeAOneTwo} from "components/Images/consent";

const consentThree = [
      {
        id: 'consent-3-learnmore',
        type: 'learnmore',
        text: '<p>Alex is grabbing Sam’s butt. By pulling away, Sam has shown, using non-verbal communication, that they do not consent. </p><p>In this instance, Alex should acknowledge Sam and stop immediately. Continuing to touch Sam without their consent is wrong and may be considered sexual assault. </p>',
        scrollText: "<span>Scroll down</span> to learn more.",
        backgroundImage: SvgConsentOne,
        learnmore: {
          title: "More about consent 🤔",
          content: "<p>Any unwanted behaviours of a sexual nature such as unwanted or inappropriate touching, like groping, that makes a person feel uncomfortable, frightened, or threatened can be considered sexual harassment and sexual assault. This is against the law and has serious consequences. The punishments for sexual assault are severe. Not only it is a crime, but the emotional consequences of sexual assault can last a lifetime.</p><p>If someone has been sexually assaulted recently, make sure they are safe, call for police or ambulance if needed. If the person is not in immediate danger, talking to someone—a trusted friend, family member, or support service—can help to figure out what to do next.</p><p>Visit <a href='https://au.reachout.com/articles/sexual-assault#4' target='_blank' >Reachout.com</a> for more information. </p>"
        },
        nextStepId: 'consent-3a-1-2',
      },
      {
        id: 'consent-3a-1-2',
        type: 'question',
        text: "<p>When Sam starts to pull away, Alex slides their hand back up. A few minutes later, they slide their hand back down again, Sam pulls away again. After a couple more times, Sam says, I’d really like you to stop. Alex stops and apologises.</p><p>How does the night proceed?</p>",
        backgroundImage:  SvgConsentThreeAOneTwo,
        options: [
          {
            id: 'consent-3a-1-2-option-1',
            text: 'Sam choses to forgive Alex, but says they don’t really feel like dancing any more. They head off the dance floor over to some mutual friends.',
            icon: '🙃',
            iconBackground: '#faf4bb',
            nextStepId: 'consent-3a-1-end'
          },
          {
            id: 'consent-3a-1-2-option-2',
            text: 'Sam doesn’t feel like Alex’s apology is very sincere and they are upset that Alex did not seem to notice their discomfort with repetitive groping. Sam walks away without a word and seeks out their friends to let them know what has happened.',
            icon: '😡',
            iconBackground:'#fad8bb',
            nextStepId: 'consent-3a-2-end',
  
          }
        ]
      },
    
      {
        id: 'consent-3a-1-end',
        type: 'learnmore',
        text: '<p>Sam has forgiven Alex after they apologised acknowledging that they were out of line. But the moment is over for Sam and Alex. They spend the rest of the night chatting to friends.</p>',
        scrollText: "<span>Scroll down</span> to learn more.",
        backgroundImage: SvgConsentThreeAOneTwo,
        learnmore: {
          title: "More about consent 🤔",
          content: "<p>Any sexual touching that occurs without the explicit consent of the recipient is sexual assault. No one has the right to touch a person in any way without consent. </p><p>For more information about consent, <a href='https://bodytalk.org.au/relationships/relationships-consent/' target='_blank'>click here</a>.</p>"
        },
        nextStepId: null,
      },
      {
        id: 'consent-3a-2-end',
        type: 'learnmore',
        text: "<p>Sam has every right to feel the way they do and not accept Alex’s apology. In this instance, Sam has headed over to friends for safety to make sure it doesn’t escalate further and for help in figuring out what to do next.</p>",
        scrollText: "<span>Scroll down</span> to learn more.",
        backgroundImage: SvgConsentThreeATwoEnd,
        learnmore: {
          title: "More about consent 🤔",
          content: "<p>Any unwanted behaviours of a sexual nature such as unwanted or inappropriate touching, like groping, that makes a person feel uncomfortable, frightened, or threatened can be considered sexual harassment and/or sexual assault. </p><p>If a person is not in immediate danger, talking to someone—a trusted friend, family member, or support service—can help to figure out what to do next. Visit <a href='https://au.reachout.com/articles/sexual-assault#4' target='_blank'>Reachout.com</a> for more information. </p>"
        },
        nextStepId: null,
      },
]

export default consentThree
